'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    validator = require('./validator'),
    util = require('./util');

var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        //o-auth binding for which icon is clicked
        $('.oAuthIcon').bind('click', function () {
            $('#OAuthProvider').val(this.id);
        });
    

        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });
        
        passwordResetPopup();

        $(function() {
        	var docReferrer = document.referrer;
            var headerHeight = $('.header__primary').get(0).getBoundingClientRect().height;
		    if(util.isMobile() && docReferrer.indexOf('PasswordResetDialog') >=0 ) {
		        $([document.documentElement, document.body]).animate({
		            scrollTop: ($("#register_auth_section").offset().top-50)
		        }, 2000);
		    }
            if(util.isMobile() && document.location.href.indexOf("register_auth_section") > -1) {
                $([document.documentElement, document.body]).animate({
		            scrollTop: ($("#register_auth_section").offset().top - headerHeight)
		        }, 1000);
            }
        })
        
        initLoginActionEvents();
    },
    passwordResetPopup : passwordResetPopup,
    initLoginActionEvents:initLoginActionEvents
}

function initLoginActionEvents()
{
    
    if(typeof initSignInEvents === 'function') {
        initSignInEvents();
    }
    
    if(typeof initSignupEventProcess === 'function') {
        initSignupEventProcess();
    }
    
    if(typeof initForgotPasswordEvents === 'function') {
        initForgotPasswordEvents();
    }
}

function passwordResetPopup(){
    $('#password-reset').on('click', function (e) {
        e.preventDefault();
        moengagePushEvent("forgot_password_click");
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                modalID: 'overlay--forgot-pass',
                modalClass: 'modal--forgot-pass align--center',
                afterCreateCallback: function (overlay, Modal) {
                    validator.init();
                    var $requestPasswordForm = $('[name$="_requestpassword"]');
                    var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
                    $($submit).on('click', function (e) {
                        if (!$requestPasswordForm.valid()) {
                            return;
                        }
                        e.preventDefault();
                        var data = $requestPasswordForm.serialize();
                        // add form action to data
                        data += '&' + $submit.attr('name') + '=';
                        // make sure the server knows this is an ajax request
                        if (data.indexOf('ajax') === -1) {
                            data += '&format=ajax';
                        }
                        $.ajax({
                            type: 'POST',
                            url: $requestPasswordForm.attr('action'),
                            data: data,
                            success: function (response) {
                                if (typeof response === 'object' &&
                                        !response.success &&
                                        response.error === 'CSRF Token Mismatch') {
                                    page.redirect(Urls.csrffailed);
                                } else if (typeof response === 'string') {
                                    Modal.updateModal(overlay, response);
                                }
                            },
                            failure: function () {
                                Modal.updateModal(overlay, '<h1>' + Resources.SERVER_ERROR + '</h1>');
                            }
                        });
                    });
                }
            }
        });
    });
}

module.exports = login;




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/login.js